import { getformData } from '@/static/js/zjs'
import request from '../static/js/request'

export const getJsSignature = (url = window.location.href) => {
  return request.get('/cms/weixin/hw/getJsSignature', {
    params: {
      url
    }
  })
}

// appid 是目标小程序的appid, 必传，小程序的scene，page路径接口已写死
export function getMiniProgramQrcode(data) {
  return request
    .post(
      `https://prd.zuul.leziedu.com/api-answer-card/open/book/get-mini-program-qrcode/${data.appid}`,
      getformData(data)
    )
    .then((res) => {
      return 'https://prd.common.leziedu.com/media/' + res.data.data.path
    })
}
